
<template>
    <b-modal :no-close-on-backdrop="true" id="modal-property-tree" title="Search Property" hide-footer :centered="true" v-model="open" ref="modal-SearchProperty">
        <b-form>
            <b-form-group label="" class="mt-0">
                <gofix-form-input class="p-color" label="Property" v-model="property" disabled required></gofix-form-input>
            </b-form-group>
            <div class="tree-scrollbar">
                <div class="contenAbsolute">
                    <div class="tree-view-properties">
                        <tree ref="tree" :data="treeData" :options="opts" @node:clicked="select">
                            <div slot-scope="{ node }" class="node-container"> {{ node.data.name }} </div>
                        </tree>
                    </div>
                </div>
            </div>
        </b-form>
        <b-button-group class="d-block text-right p-1rem">
            <gofix-button :disabled="disabled" label="APPLY" @click="applyData" noBorder></gofix-button>
        </b-button-group>
    </b-modal>
</template>
<script>

import { mapGetters } from 'vuex';
import LiquorTree from 'liquor-tree'
export default {
    name: 'modal-property-category',
    components: {
        [LiquorTree.name]: LiquorTree,
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        contract_id: {
            type: Number,
            default: false
        },
        property_id: {
            type: Number,
            default: null
        },
        propertySelected: {
            type: Object,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            open: false,
            property: null,
            treeData: [],
            rootId: null,
            selectedNode: null,
            opts: {
                minFetchDelay: 500,
                fetchData: (node) => {
                    node.isBatch = false;
                    if (node.data.id == this.rootId) {
                        return new Promise((resolve, reject) => {
                            resolve([]);
                        });
                    }
                    return new Promise((resolve, reject) => {
                        global.axios(`api/properties/tree`, {
                                method: "GET",
                                params: {
                                    property_id: node.data.id
                                },
                                headers: {
                                    Accept: "application/json",
                                }
                            })
                            .then(response => {
                                resolve(response.data.data);
                            })
                            .catch(error => reject(error));
                    });
                }
            },
        }
    },
    watch: {
        value: function (val) {
            if(val) {
                if(this.propertySelected && this.propertySelected.data && this.propertySelected.data.name) 
                    this.property = this.propertySelected.data.name;
            }
            this.open = val;
        },
        open: function (val) {
            this.$emit('input', val);
        },
        contract_id: function(val) {
            this.getData();
        },
        property_id: function(val) {
            this.getData();
        },
    },
    computed: {
        ...mapGetters({
            Item: "CaseManagementController/Item",
        }),
    },
    created() {
        this.getData();
    },
    methods: {
        getData() {
            this.rootId = null;
            this.treeData = [];
            if(!this.contract_id) return;
            return new Promise((resolve, reject) => {
                global.axios(`api/properties/tree`, {
                        method: "GET",
                        params: {
                            contract_id: this.contract_id,
                            property_id: this.property_id ? this.property_id : null,
                            self: 1
                        },
                        headers: {
                            Accept: "application/json",
                        }
                    })
                    .then(response => {
                        if(response.data.data[0].children && response.data.data[0].children.length) {
                            response.data.data[0].children.map(item => item.isBatch = false)
                            this.treeData = response.data.data[0].children
                        } else {
                            response.data.data[0].state = {
                                selected: true,
                                expanded: true,
                                disabled: true
                            };
                            this.treeData = response.data.data
                        }
                        
                        // this.rootId = response.data.data[0].id;
                        resolve(response.data.data);
                    })
                    .catch(error => reject(error));
            });
        },
        select(node) {
            this.property = node.data.name;
            this.selectedNode = node.data;
        },
        applyData() {
            const node = Object.assign({}, this.selectedNode, {
                data: this.selectedNode
            });
            this.$emit('updateData', node)
            this.open = false;
        }
    }
}
</script>